angular.
module("dx.webapp.api").
factory("dxApiV1Gradings", function apiV1GradingsService(
	$http
) {
	"use strict";

	function shareGradingsRecipientsGet(examId) {
		return $http.get("api/v1/gradings/" + examId + "/shares/recipients");
	}

	function shareGradingRecipientDelete(examId, userId) {
		return $http.delete("api/v1/gradings/" + examId + "/shares?userId=" + userId);
	}

	return {
		shares: {
			get: shareGradingsRecipientsGet,
			delete: shareGradingRecipientDelete,
		},
	};
});
